import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { BarChartBlock as BarChartBlockType } from '../../viz.types';
import VizBlockFrame from '../VizBlockFrame';
import VizTotal from '../VizTotal';
import { useBarChartBlock } from './useBarChartBlock';

interface BarChartBlockProps {
  block: BarChartBlockType;
}

const BAR_HEIGHT = 8;
const LABEL_MAX_LINES = 2;

const BarChartBlock = ({ block }: BarChartBlockProps) => {
  const { formatters, barRadius, total, bars } = useBarChartBlock(block);

  return (
    <VizBlockFrame
      title={block.title}
      subtitle={block.subtitle}
      header={total && <VizTotal value={total} />}
    >
      <Stack sx={{ gap: 2 }}>
        {bars.map((bar, index) => (
          <Tooltip
            key={index}
            placement="top"
            fullWidth
            TooltipContent={`${bar.label}: ${formatters.formatFull(bar.value)}`}
          >
            <Stack sx={{ flex: 1, gap: 0.75, minWidth: 0 }}>
              <Stack direction="row" alignItems="baseline" sx={{ gap: 2 }}>
                <Typography
                  variant="body2"
                  sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    display: '-webkit-box',
                    WebkitLineClamp: LABEL_MAX_LINES,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    overflowWrap: 'anywhere',
                  }}
                >
                  {bar.label}
                </Typography>
                <Typography variant="body2" noWrap sx={{ flexShrink: 0 }}>
                  {formatters.formatCompact(bar.value)}
                </Typography>
              </Stack>
              <Box
                sx={{
                  width: `${bar.ratio * 100}%`,
                  height: BAR_HEIGHT,
                  borderRadius: barRadius,
                  background: bar.background,
                }}
              />
            </Stack>
          </Tooltip>
        ))}
      </Stack>
    </VizBlockFrame>
  );
};

export default BarChartBlock;
